import React from 'react';

interface AIButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  [key: string]: any;
}

const AIButton: React.FC<AIButtonProps> = ({ onClick, disabled = false, ...props }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="relative group"
      style={{
        background: 'linear-gradient(135deg, #a855f7 0%, #3b82f6 50%, #ec4899 100%)',
        border: 'none',
        borderRadius: '16px',
        padding: '0 12px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        transition: 'all 0.3s ease',
        opacity: disabled ? 0.5 : 1,
        boxShadow: '0 2px 8px rgba(168, 85, 247, 0.3)',
        height: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.transform = 'translateY(-1px)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(168, 85, 247, 0.5)';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 2px 8px rgba(168, 85, 247, 0.3)';
      }}
      {...props}
    >
      <div className="flex items-center gap-1">
        {/* Ícono de estrellas AI */}
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ display: 'block' }}
        >
          <path
            d="M12 2L14.5 9.5L22 12L14.5 14.5L12 22L9.5 14.5L2 12L9.5 9.5L12 2Z"
            fill="white"
            opacity="0.95"
          />
          <path
            d="M19 5L20 7.5L22.5 8.5L20 9.5L19 12L18 9.5L15.5 8.5L18 7.5L19 5Z"
            fill="white"
            opacity="0.75"
          />
        </svg>

        {/* Texto AI */}
        <span
          style={{
            color: 'white',
            fontWeight: 600,
            fontSize: '12px',
            letterSpacing: '0.3px',
            lineHeight: '1',
            display: 'block',
          }}
        >
          IA
        </span>
      </div>
    </button>
  );
}; export default AIButton;
